import { lazyRouteComponent } from "@tanstack/react-router";
import { ScanSearch } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { BACKTEST_PERIODS, type BacktestPeriod } from "./scan";

export const SCREENER_TABS = ["scan", "live"] as const;
export type ScreenerTab = (typeof SCREENER_TABS)[number];

export interface ScreenerSearch {
  /** "live": the intraday live scans. Default: the scan builder. */
  tab?: ScreenerTab;
  /** The live scan shown on the live tab. */
  scan?: string;
  /** The scan that was run (the editor starts from it). */
  expr?: string;
  /** nifty50, nifty500, all, or a comma list of symbols. Default nifty500. */
  universe?: string;
  /** "YYYY-MM-DD": run as of that day (default: the latest). */
  date?: string;
  /** Back-test period, when one was asked for. */
  bt?: BacktestPeriod;
}

export const pages: PageDef[] = [
  {
    path: "/app/screener",
    proOnly: true,
    title: "Screener",
    component: lazyRouteComponent(() => import("./ScreenerPage"), "ScreenerPage"),
    nav: { label: "Screener", icon: ScanSearch, group: "Premium", order: 10 },
    validateSearch: (s): ScreenerSearch => ({
      ...(s.tab === "live" ? { tab: "live" as const } : {}),
      ...(typeof s.scan === "string" && /^[a-z0-9_]{1,40}$/.test(s.scan) ? { scan: s.scan } : {}),
      ...(typeof s.expr === "string" && s.expr.trim() && s.expr.length <= 2000 ? { expr: s.expr } : {}),
      ...(typeof s.universe === "string" && /^[A-Za-z0-9&\-_.,]{1,4000}$/.test(s.universe) ? { universe: s.universe } : {}),
      ...(typeof s.date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s.date) ? { date: s.date } : {}),
      ...(typeof s.bt === "string" && (BACKTEST_PERIODS as readonly string[]).includes(s.bt) ? { bt: s.bt as BacktestPeriod } : {}),
    }),
  },
];
